<template>
  <div class="filter-container">
    <!-- default filter -->
    <div class="row">
      <!-- search filter -->
      <div class="small-12 medium-6 large-7 columns">
        <div class="ui form">
          <div class="field">
            <form autocomplete="off">
              <input v-model="searchFilter"
                     data-v-desktop-logged-out-step="1"
                     placeholder="Keress pályát..."
                     type="text"/>
            </form>
          </div>
        </div>
      </div>
      <!-- ./search filter -->
      <!-- filter buttons -->
      <div class="small-12 medium-5 large-4 columns">
        <button class="ui button primary"
                @click="applySearchFilter">Keresés
        </button>
        <button class="ui button"
                data-v-desktop-logged-out-step="2"
                @click="toggleDetailedFilter">Részletes keresés
        </button>
      </div>
      <div v-if="!isMobileDevice"
           class="small-2 medium-1 large-1 columns"
           data-v-desktop-logged-out-step="3">
        <i v-if="!isListView"
           class="th list icon view-icon"
           title="Lista nézet"
           @click="toggleClientView"></i>
        <i v-else
           class="table icon view-icon"
           title="Kártya nézet"
           @click="toggleClientView"></i>
      </div>
      <!-- ./filter buttons -->
    </div>
    <!-- default filter -->
    <!-- detailed filter -->
    <div :class="{'active': isDetailedFilterOpen && !isMobileDevice, 'mobile-active': isDetailedFilterOpen && isMobileDevice}"
         class="row detailed-filter">
      <!-- subject type filter -->
      <div class="small-12 medium-3 columns">
        <div class="ui form">
          <div class="field">
            <label>Játék</label>
            <select v-model="selectedGlobalSubjectType">
              <option v-for="globalSubjectType in globalSubjectTypesForFilter"
                      :value="globalSubjectType.key">
                {{ globalSubjectType.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <!-- ./subject type filter -->
      <!-- date filter -->
      <div class="small-12 medium-3 columns">
        <div class="ui form">
          <div class="field">
            <form>
              <label class="filter-datepicker-label">Nap</label>
              <input v-model="selectedFilterDate"
                     :min="currentDate"
                     type="date"/>
              <!--
                <date-picker v-model="selectedFilterDate"
                             id="filterDatepicker"
                             :first-day-of-week="1"
                             :editable="false"
                             :clearable="false"
                             :not-before="today"
                             :lang="DATE_PICKER_LANG"></date-picker>
              -->
            </form>
          </div>
        </div>
      </div>
      <!-- ./date filter -->
      <!-- time filter -->
      <div class="small-12 medium-3 columns">
        <div class="ui form">
          <div class="field">
            <label>Időpont</label>
            <select v-model="selectedFilterTime">
              <option v-for="time in timeSelectOptions"
                      :value="time">
                {{ time }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <!-- ./time filter -->
      <!-- filter button -->
      <div class="small-12 medium-3 columns label-space-helper">
        <button class="ui button primary"
                @click="applyTimeFilter">Időpont keresés
        </button>
      </div>
      <!-- ./filter button -->
      <!-- location set -->
      <div class="small-12 medium-3 columns">
        <!--
        <google-auto-complete @on-changed="selectPosition"/>
        -->
        <div v-if="isAccessCurrentPosition"
             class="actual-position-text">
          <span><i class="crosshairs icon"></i></span>
          <button class="ui button"
                  @click="openCitySelectModal">
            Városválasztó
          </button>
        </div>
        <div v-else>
          <div v-if="hasPositionData"
               class="label-space-helper">
            <button class="ui icon button"
                    @click="getGeolocationPermission">
              <i class="crosshairs icon"></i>
            </button>
            <button class="ui button"
                    @click="openCitySelectModal">
              Városválasztó
            </button>
          </div>
          <span v-else>
            <button class="ui button actual-position-button"
                    @click="getGeolocationPermission">Helymeghatározás engedélyezése</button>
          </span>
        </div>
      </div>
      <!-- ./location set -->
      <!-- distance filter -->
      <div v-if="isAccessCurrentPosition || hasPositionData"
           class="small-12 medium-3 columns">
        <div class="ui form">
          <div class="field">
            <label>Távolság</label>
          </div>
        </div>
        <vue-slider v-model="distanceFilter"
                    class="slider-km"
                    v-bind="rangeSliderOptions"/>
      </div>
      <div v-else
           class="small-12 medium-3 columns label-space-helper">
        <button class="ui button"
                @click="openCitySelectModal">Válassz egy várost
        </button>
      </div>
      <!-- ./distance filter -->
      <!-- filter button -->
      <div class="small-12 medium-6 columns label-space-helper">
        <button class="ui button primary"
                @click="applyOtherFilter(false)">Szűrés
        </button>
        <button class="ui button primary"
                @click="applyOtherFilter(true)">Mind
        </button>
        <button class="ui button"
                @click="resetFilters">Alaphelyzet
        </button>
        <button class="ui button"
                @click="toggleDetailedFilter">Bezár
        </button>
      </div>
      <!-- ./filter button -->
    </div>
    <!-- detailed filter -->
    <city-select-modal @set-position="selectPosition"/>
  </div>
</template>

<script>
import GoogleAutoComplete from './GoogleAutoComplete'
import CitySelectModal from '../modal/CitySelectModal'
import VueSlider from 'vue-slider-component'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import notify from '../../notify'

export default {
  props: ['isMobileDevice'],
  data () {
    return {
      searchFilter: '',
      selectedGlobalSubjectType: 'squash',
      selectedFilterDate: null,
      selectedFilterTime: null,
      distanceFilter: 50,
      rangeSliderOptions: {
        min: 0,
        max: 50,
        'tooltip-dir': 'bottom',
        tooltipStyle: {
          backgroundColor: '#b7bfc9',
          borderColor: '#b7bfc9',
          borderRadius: '0',
          border: 'none',
          color: 'black',
          padding: '3px 8px',
        },
        processStyle: {
          backgroundColor: '#bfc5ce',
          borderRadius: '0',
        },
        piecewiseStyle: {
          backgroundColor: 'red',
          border: '2px solid green',
        },
        piecewiseActiveStyle: {
          backgroundColor: 'blue',
          border: 'none',
        },
        labelStyle: {
          backgroundColor: 'red',
        },
      },
      today: moment().format('YYYY-MM-DD'),
      DATE_PICKER_LANG: this.$store.state.DATE_PICKER_LANG,
    }
  },
  methods: {
    applySearchFilter () {
      /* eslint-disable */
      $('html, body').animate({
        scrollTop: ($('.filter-container').offset().top - 50),
      }, 500)

      this.$store.dispatch('unSelectClient');
      this.$emit('apply-filters', { searchFilter: this.searchFilter })
    },
    applyTimeFilter () {
      /* eslint-disable */
      $('html, body').animate({
        scrollTop: ($('.filter-container').offset().top - 50),
      }, 500)
      let curDate = moment()
      if (!this.selectedGlobalSubjectType || this.selectedGlobalSubjectType === 'all') {
        notify.info('Adjon meg egy játékot')
      } else {
        if (!this.selectedFilterDate) {
          notify.info('Adjon meg egy érvényes dátumot')
        } else {
          let selectedDate = moment(this.selectedFilterDate)
          if (selectedDate.isBefore(curDate, 'day')) {
            this.selectedFilterDate = null
            notify.info('Nem adható meg multbéli dátum ')
          } else {
            if (!this.selectedFilterTime || typeof this.selectedFilterTime !== 'string') {
              notify.info('Kérjük adja meg a kezdés időpontját')
            } else {
              this.$emit('set-pagination-page', 1)
              this.$parent.$emit('fetch-free-clients-at-this-datetime', {
                date: selectedDate.format('YYYY-MM-DD'),
                time: this.selectedFilterTime,
                globalSubjectType: this.selectedGlobalSubjectType,
              })
            }
          }
        }
      }
    },
    selectPosition (position) {
      console.log('position: ')
      console.log(position)
      let currentPosition = { lat: position.lat, lng: position.lng }
      this.$store.dispatch('setCurrentPosition', { currentPosition: currentPosition })
      this.$store.dispatch('isAccessCurrentPosition', { isAccessCurrentPosition: false })
    },
    applyOtherFilter (showAll) {
      /* eslint-disable */
      $('html, body').animate({
        scrollTop: ($('.filter-container').offset().top - 50),
      }, 500)

      this.$store.dispatch('unSelectClient');
      this.$emit('apply-filters', { distanceFilter: showAll ? 10000 : this.distanceFilter })
    },
    resetFilters () {
      this.searchFilter = ''
      this.selectedFilterDate = null
      this.selectedFilterTime = null
      this.distanceFilter = 50

      this.$store.dispatch('unSelectClient');
      this.$store.dispatch('setFilteredFreeClients', false)
      this.$emit('apply-filters', { searchFilter: this.searchFilter, distanceFilter: this.distanceFilter })
    },
    toggleDetailedFilter () {
      this.$store.dispatch('toggleDetailedFilterOpen')
    },
    toggleClientView () {
      this.$store.dispatch('unSelectClient');
      /* eslint-disable */
      // $('#scheduleTableContainer').appendTo('#schedule-table-default-place')
      this.$store.dispatch('toggleClientView')
    },
    getGeolocationPermission () {
      let self = this
      navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
        if (result.state === 'granted') {
          // notify.warning('A helymeghatározás már engedélyezve van, ha problémát tapasztalsz frissítsd az oldalt')
          self.getMyPosition()
          notify.info('Pozíció frissítve')
        } else if (result.state === 'prompt') {
          self.$emit('get-my-position')
          navigator.geolocation.getCurrentPosition(function success () {
            console.log('success')
          }, function error () {
            console.log('error')
          })
        } else if (result.state === 'denied') {
          notify.warning('Sajnos le van tiltva a helymeghatározás a böngésződben, engedélyezd a használathoz')
        }
        result.onchange = function () {
          console.log('geolocation permission state has changed to ', this.state);
        };
      });
    },
    openCitySelectModal () {
      this.$modal.show('city-select-modal')
    },
    getMyPosition () {
      this.$emit('get-my-position')
    },
  },
  computed: {
    globalSubjectTypesForFilter () {
      let globalTypes = []
      // globalTypes.push({key: 'all', name: 'Összes'})
      globalTypes = globalTypes.concat(this.$store.state.globalSubjectTypes.slice(0))
      return globalTypes
    },
    timeSelectOptions () {
      return ['06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00',
        '18:00', '19:00', '20:00', '21:00', '22:00']
    },
    isAccessCurrentPosition () {
      return this.$store.state.isAccessCurrentPosition
    },
    isDetailedFilterOpen () {
      return this.$store.state.isDetailedFilterOpen
    },
    isListView () {
      return this.$store.state.isListView
    },
    currentDate () {
      return moment().format('YYYY-MM-DD')
    },
    hasPositionData () {
      return !!this.$store.state.currentPosition
    },
  },
  mounted: function () {
    this.$store.dispatch('setMountedState', { name: 'filterForClients', state: true })
  },
  components: {
    VueSlider,
    GoogleAutoComplete,
    DatePicker,
    CitySelectModal,
  },
}
</script>

<style scoped>
.filter-container {
  margin: 1rem 0;
  font-weight: 400;
  background: #a0a9b6;
  min-height: 2.85714286em;
  padding: 0.5rem 0;
  color: #e9e9e9;
  position: absolute;
  width: 100vw;
  left: 0;
}

.filter-container .ui.form label {
  color: #d7d9dc;
}

.filter-container .ui.form select, .field > form > input {
  background: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  border: 2px solid #b7bfc9 !important;
}

.filter-container .ui.form select:focus {
  outline: none;
}

.button {
  white-space: nowrap;
  border-radius: 0;
}

.label-space-helper {
  padding-top: 1.6rem;
}

.detailed-filter {
  height: 0;
  overflow: hidden;
  transition: height 1s ease-in;
}

.detailed-filter.active {
  height: 150px;
  max-height: 500px;
  padding-bottom: 1rem;
  transition: height 1s ease-in;
}

.detailed-filter.mobile-active {
  height: 500px;
  transition: height 1s ease-out;
}

.view-icon {
  font-size: 200%;
  cursor: pointer;
}

.filter-datepicker-label {
  font-weight: 600;
  font-size: 92%;
}

.actual-position-text {
  margin: 1rem;
  font-size: 1rem;
  font-weight: bold;
}

.actual-position-button {
  white-space: normal;
  margin-top: .5rem;
}
</style>
